(() => {
  angular
    .module('gm.common.2fa')
    .factory('Gmy2FA', Gmy2FA);

  function Gmy2FA(
    $q,
    GmyModal,
    gmApi
  ) {
    'ngInject';

    return {
      executeWith2FA,
      update2FASettings,
    };

    function executeWith2FA(fn, type = 'default') {
      const deferred = $q.defer();

      fn()
        .then(deferred.resolve)
        .catch((error) => {
          if (error.data && error.data.message
            && error.data.message === 'error.expecting.twoFA.code') {
            return GmyModal.showModal({
              templateUrl: 'modules/2fa/controllers/two-factor-auth.html',
              controller: 'twoFAModalController',
              controllerAs: 'twoFACtrl',
              inputs: {
                type,
                requestSMS: () => {
                  fn({
                    code: '',
                    requestSMS: true
                  });
                }
              },
            }).then(modal => modal.closed.then((code) => {
              fn({
                code,
                requestSMS: false
              })
              .then(deferred.resolve)
              .catch(deferred.reject);
            }));
          }
          return deferred.reject(error);
        });

      return deferred.promise;
    }

    function update2FASettings(modify, twoFactAuth) {
      return gmApi.put('users/2fa', {
        modify
      }, {
        twoFactAuth,
        auth: true
      });
    }
  }
})();
